
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    SAMLABREPORT_ACTION,
    ALL_SAMLABREPORT,
    ADD_SAMLABREPORT,
    FETCH_SAMLABREPORT,
    DELETE_SAMLABREPORT,
    EDIT_SAMLABREPORT
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * SAM LAB REPORT Actions
 */

    export const allSamLabReport = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: SAMLABREPORT_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqsamlabreport', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_SAMLABREPORT, payload: alldata });
            });
        }        
    
    }

    export const addSamLabReport = (data, selfile) =>{
    
        var payload={
            "student":data.target.student.value,
            "date":data.target.seldate.value,
            "setup":data.target.setup.value,
            "aimperception":data.target.aimper.value,
            "aim":data.target.aimval.value,
            "faceimpact":data.target.factimpact.value,
            "path":data.target.pathval.value,
            "contact":data.target.contact.value,
            "launch":data.target.launch.value,
            "facepath":data.target.facepath.value,
            "acceleration":data.target.acceleration.value,
            "drills":data.target.drills.value,
            "reportname":data.target.reportname.value,
            "fileupl":selfile,
        }
        return (dispatch) => { 
            dispatch({ type:SAMLABREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/uploadtqsamlabreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allSamLabReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_SAMLABREPORT});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }    
    
    export const fetchSamLabReport = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:SAMLABREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtqsamlabreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_SAMLABREPORT, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteSamLabReport = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:SAMLABREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqsamlabreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allSamLabReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_SAMLABREPORT});                    
                }                
                
            });
        
        }
    }


    export const editSamLabReport = (data) => {
        const payload = {
            student: data.target.student,
            date: data.target.seldate,
            setup: data.target.setup,
            aimperception: data.target.aimperception,
            aim: data.target.aim,
            faceimpact: data.target.faceimpact,
            path: data.target.pathval,
            contact: data.target.contact,
            launch: data.target.launch,
            facepath: data.target.facepath, 
            acceleration: data.target.acceleration,
            drills: data.target.drills,
            reportname: data.target.reportname,
            fileupl: data.target.fileupl,
            oldfiles: data.oldfiles,
            id: data.id 
        };
    
        return async (dispatch) => {
            dispatch({ type: SAMLABREPORT_ACTION });
    
            try {
                const response = await axios.post(AppConfig.apiurl + '/api/edittqsamlabreport', payload, { headers: AuthHeader.header });
                const resdata = response.data;
                if (resdata.status === 1) {
                    await allSamLabReport()(dispatch);
                    NotificationManager.success(resdata.message);
                    const { samLabReportData } = store.getState().yourReducer; 
                    dispatch({ type: EDIT_SAMLABREPORT, payload: samLabReportData });
                }
                return Promise.resolve(resdata);
            } catch (error) {
                console.error('Error during editSamLabReport:', error);
                return Promise.reject(error);
            }
        };
    };
    

